module.exports = __webpack_public_path__ + "static/img/Pfiffner1.b6ce3a3a.jpg";